import OnboardingTable from 'components/templates/ccm/practice/onboardingStatus/patientsTable';
import CcmOnboardingFilter from 'components/templates/ccm/practice/onboardingStatus/filter';
import {
  useOnboardingStatus,
  useOnboardingStatusQueryFilter,
  useOnboardingStatusReport,
  useSendReport,
} from 'infrastructure/hooks/ccm/onboarding-status-report';
import OnboardingStatusCount from 'components/molecules/onboarding-status-count';
import { Col, Row } from 'reactstrap';
import { ModuleType } from 'infrastructure/enums';
import { useTranslation } from 'react-i18next';
import OnboardingNavigationHeader from 'components/molecules/onboarding-status-header';
import OnboardingStatusGraphs from 'components/molecules/onboarding-status-count/graphs';

import s from './styles.module.scss';

const CcmOnboardingStatus = () => {
  const { filter } = useOnboardingStatusQueryFilter();
  const { data, isLoading } = useOnboardingStatus(filter);
  const { patients, patientsLoading } = useOnboardingStatusReport(filter);
  const { sendReport, sendLoading } = useSendReport();
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <OnboardingNavigationHeader
        hasPatients={Boolean(patients.patients?.length)}
        title={t('labels.ccmOnboardingStatusReport')}
        loading={sendLoading}
        onClick={() => {
          sendReport(filter);
        }}
      />
      <div className={s.body}>
        <OnboardingStatusCount
          statuses={data?.statuses}
          loading={isLoading}
          module={ModuleType.CCM}
        />
        <OnboardingStatusGraphs
          statusBlocks={data?.statuses}
          insuranceBlocks={data?.insurances ?? []}
          loading={isLoading}
          module={ModuleType.CCM}
        />
        <CcmOnboardingFilter />
        <Row>
          <Col xs="12">
            <OnboardingTable
              patients={patients?.patients ?? []}
              count={patients?.patientCount}
              loading={patientsLoading}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CcmOnboardingStatus;
